// this component is resposible for creating top bar(which includes search, filter, sort, upload, download and reset)
// this component also contain logic of pagination
import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import DoctorMyPatientsMainContent from "../DoctorMyPatients/DoctorMyPatientsMainContent";
import UploadPatients from "./uploadpatients";
import PatientSuccess from "./patientsuccess";
import AuthPopup from "./AuthFunction";
import CloseIcon from "../../../assets/close_icon.png";
import SearchIcon from "../../../assets/search_icon.svg";
import DocumentDown from "../../../assets/document_down.svg";
import RefreshRound from "../../../assets/Refresh_round.svg";
import UploadIcon from "../../../assets/Upload_Icon.svg";
import afterLogin from "../../../Util/API Calls/afterLogin";
import FilterDoctorMyPatientsModal from "./FilterDoctorMyPatientsModal";
import DisabledDownload from "../../../assets/Group 25467.svg";
import DownloadReport from "../../DownloadReport/DownloadReport";
import closeIcon from "../../../assets/forhomepage/close_icon.svg";
import { useHistory } from "react-router-dom";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import FooterPagination from "../../common/FooterPagination";
import { C2CConsole } from "../../../Util/Helper/C2CConsole";

const DoctorMyPatientLayout = (props) => {
  const { activeIndex, setActiveIndex } = props;

  const [drawerOpen, setdrawerOpen] = useState(false);
  const [successModal, setsuccessModal] = useState(false);
  const [showAuthPopup, setshowAuthPopup] = useState(false);
  const [inputText, setInputText] = useState("");
  let history = useHistory();
  // modification logic here =>
  const debouncedSearchTerm = useDebounce(inputText, 500);
  const urlParams = new URLSearchParams(window?.location?.search);
  const pageNumber = urlParams?.get("pageNo");
  const defaultSetUp = {
    show_upcoming: false,
    search_string: "",
    sort_by_latest: true,
    page_no: pageNumber ? +pageNumber : 1,
    rows_per_page: 10,
  };
  const [term, setTerm] = useState(defaultSetUp);
  const downloadRef = React.useRef();
  const [disableDownload, setDisableDownload] = useState(false);
  const [downloadReport, setDownloadReport] = useState([]);

  let is_staff = localStorage.getItem("user_type");
  let userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  let staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);

  //use effect to page number when user click on back button from view details page
  useEffect(() => {
    if (props.pageNumberBack !== undefined && props.pageNumberBack !== null) {
      setActiveIndex(props.pageNumberBack);
    }
  }, [props.pageNumberBack]);

  const onFilterSubmit = (event) => {
    let tempTerm = term;
    if ("show_upcoming" in event) {
      tempTerm["show_upcoming"] = event["show_upcoming"];
    }
    if ("search_string" in event) {
      tempTerm["search_string"] = event["search_string"];
    }
    if ("sort_by_latest" in event) {
      tempTerm["sort_by_latest"] = event["sort_by_latest"];
      localStorage.setItem("patientSortFilter", event["sort_by_latest"]);
    }
    if ("page_no" in event) {
      tempTerm["page_no"] = event["page_no"];
    }
    //  else {
    //   tempTerm["page_no"] = 1;
    //   setActiveIndex(1);
    // }

    tempTerm["doctor_id"] = props.temp_doctor_selected;
    tempTerm["rows_per_page"] = 10;
    setTerm(tempTerm);
    props.onSubmit(term);
  };

  const onSubmit = (event) => {
    setInputText(event["search_string"]);
    // onFilterSubmit(event);
  };

  const clearData = () => {
    setInputText("");
    term["page_no"] = 1;
    setActiveIndex(1);
    onFilterSubmit({ search_string: "" });
  };

  // Only call effect if debounced search term changes

  function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);
    return debouncedValue;
  }

  useEffect(
    () => {
      if (debouncedSearchTerm && debouncedSearchTerm.length) {
        onFilterSubmit({ search_string: debouncedSearchTerm, page_no: 1 });
        setActiveIndex(1);
      } else {
        onFilterSubmit({ search_string: "" });
      }
    },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  // END Only call effect if debounced search term changes

  const resetClick = (event) => {
    if ("search_string" in event) {
      term["search_string"] = "";
    }
    if ("show_upcoming" in event) {
      term["show_upcoming"] = false;
    }
    if ("sort_by_latest" in event) {
      term["sort_by_latest"] = true;
      localStorage.setItem("patientSortFilter", true);
    }
    if ("rows_per_page" in event) {
      term["rows_per_page"] = 10;
    }
    term["doctor_id"] = props.temp_doctor_selected;
    term["page_no"] = 1;
    setActiveIndex(1);
    setInputText("");
    setTerm(event);
    props.onSubmit(term);
  };

  // pagination ui creation logic =>
  const onPageChange = (index) => {
    setActiveIndex(index);
    onFilterSubmit({ page_no: index });
    history.replace(`/doctor/account/mypatients?pageNo=${index}`);
  };

  const handleOTPSuccess = () => {
    downloadData(term);
  };

  const handleDisableDownload = () => {
    setDisableDownload(false);
  };

  const downloadData = (term) => {
    let payload;
    is_staff === "staff"
      ? (payload = {
          doctor_id: Array.isArray(props.temp_doctor_selected)
            ? props.temp_doctor_selected
            : [props.temp_doctor_selected],
          staff_id: staffId,
          search_string: term.search_string,
          sort_by_latest: term.sort_by_latest,
          show_upcoming: term.show_upcoming,
          download_csv: "true",
        })
      : (payload = {
          doctor_id: userId,
          search_string: term?.search_string,
          sort_by_latest: term?.sort_by_latest,
          show_upcoming: term?.show_upcoming,
          download_csv: "true",
        });
    afterLogin
      .post(
        `/download-report`,
        {
          report_type: "patient",
          user_type: localStorage.getItem("user_type"),
          payload: {
            ...payload,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((res) => {
        if (res && res.data.message === "request published successfully") {
          downloadRef.current.showDownloadReport();
          localStorage.setItem("DownloadReport", "true");
          localStorage.setItem("PatientDisableDownload", "true");
          setDisableDownload(true);
          let arr = [];
          arr = localStorage.getItem("DownloadReportArr")
            ? JSON.parse(localStorage.getItem("DownloadReportArr"))
            : [];
          arr.push({
            id: res.data.request_id,
            filename: res.data.filename,
            requestType: "patient",
            pause: false,
          });
          localStorage.setItem("DownloadReportArr", JSON.stringify(arr));
          setDownloadReport(arr);
        }
      })
      .catch((err) => C2CConsole.log(err));
  };

  const requestDownload = () => {
    if (is_staff === "staff") {
      downloadData(term);
    }
    // else if (allowDownload === true) {
    //   downloadData();
    // }
    else {
      setshowAuthPopup(true);
    }
  };

  const openSuccesModal = () => {
    setdrawerOpen(false);
    setsuccessModal(true);
  };

  useEffect(() => {
    if (
      localStorage.getItem("PatientDisableDownload") &&
      localStorage.getItem("PatientDisableDownload") === "true"
    ) {
      setDisableDownload(true);
    } else {
      setDisableDownload(false);
    }
  }, []);

  const handleCloseOtpModal = () => {
    setshowAuthPopup(false);
  };

  // <=
  return (
    <>
      <div className="row mt-3 mx-0">
        <div className="col-lg-3 col-12 mb-4 mb-lg-2 order-3 order-md-12 d-flex flex-row justify-content-lg-start justify-content-center top_heading_for_mobile">
          <div
            className="row m-0 d-flex flex-row"
            style={{
              width: "100%",
              alignItems: "center",
              justifyContent: "end",
            }}
          >
            {is_staff === "staff" ? (
              ""
            ) : (
              <div className="page_heading_mob">
                <div className="">
                  <h1 className="m-0 p-0">My Patients</h1>
                </div>
              </div>
            )}
            <div className="d-flex patient_filter_main_cont">
              <div
                className={`dropdown patient_filter_box mr-2 ${
                  is_staff === "staff" ? "disabled" : ""
                }`}
                data-tooltip={`${
                  is_staff === "staff" ? "" : "Download Report"
                }`}
                data-tooltip-conf="bottom"
              >
                <button
                  className="btn btn-outline-primary"
                  onClick={
                    is_staff === "staff" || disableDownload
                      ? ""
                      : requestDownload
                  }
                  style={{
                    cursor:
                      disableDownload || is_staff === "staff"
                        ? "not-allowed"
                        : "",
                  }}
                >
                  {/* <i className="fa fa-download" aria-hidden="true"></i> */}
                  <img
                    src={
                      is_staff === "staff" || disableDownload
                        ? DisabledDownload
                        : DocumentDown
                    }
                    alt="DocumentDown"
                  />
                </button>
              </div>

              <div
                className="dropdown patient_filter_box mr-2"
                data-tooltip="Reset all"
                data-tooltip-conf="bottom"
              >
                <button
                  className="btn btn-outline-secondary"
                  type="button"
                  onClick={() => resetClick(defaultSetUp)}
                >
                  {/* <i className="fa fa-refresh" aria-hidden="true"></i> */}
                  <img src={RefreshRound} alt="#" />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-5 col-10 order-2">
          <div className="search_filter_div d-flex align-items-center">
            <span>
              <img src={SearchIcon} alt="search icon not find" />
            </span>
            <input
              className="w-100 search_filter_input"
              type="text"
              placeholder="Search by patient name or mobile number."
              onChange={(e) => onSubmit({ search_string: e.target.value })}
              value={inputText}
            />
            {inputText !== "" && (
              <div
                className="close_serch"
                style={{ width: "28px", fontSize: "7px" }}
              >
                <img src={closeIcon} onClick={clearData} alt="clear" />
              </div>
            )}
          </div>
        </div>
        <div className="col-lg-4 col-2 order-3 upload_patients_btn_cont">
          <button
            className="btn btn-primary rounded-pill mr-2 upload_patient_btn"
            data-tooltip="Upload Patient Data"
            data-tooltip-conf="bottom"
            onClick={() => {
              setdrawerOpen(true);
            }}
          >
            {/* <i className="fa fa-upload" aria-hidden="true"></i> */}
            <img
              src={UploadIcon}
              art="upload icon not find"
              style={{ width: "13px" }}
            />
            <span className="upload_text_mob">&nbsp;Upload Patients</span>
          </button>
        </div>
      </div>
      {props.pageCount === 0 ? (
        <div className="col-12">
          <div className="row header mx-2 mt-3 mb-2 d-none d-lg-flex">
            No Record found
          </div>
        </div>
      ) : (
        <>
          <DoctorMyPatientsMainContent
            patients={props.patients}
            pageNumb={activeIndex}
            allDoctorsRelated={props.allDoctorsRelated}
            doctorsRelatedDataStatus={props.doctorsRelatedDataStatus}
            downloadData={downloadData}
            selectedDoctorsRelatedData={props.selectedDoctorsRelatedData}
            handleDoctorList={props.handleDoctorList}
            resetFilter={props.resetFilter}
            getAllDoctorsRelatedData={props.getAllDoctorsRelatedData}
            allDoctorsRelatedData={props.allDoctorsRelatedData}
            doctorFilterList={props.doctorFilterList}
            selectedDoctorFilter={props.selectedDoctorFilter}
            selectedDoctorFilterDrop={props.selectedDoctorFilterDrop}
          />
          {props.pageCount !== 1 && props.totalCount !== 0 && (
            <div className="doctor-my-patient-layout-footer">
              <FooterPagination
                currentPage={props.currentPage}
                totalCount={props.totalCount}
                pageSize={10}
                onPageChange={onPageChange}
              />
            </div>
          )}
        </>
      )}
      <UploadPatients
        open={drawerOpen}
        onClose={() => setdrawerOpen(false)}
        refetchPatients={props.refreshData}
        openSuccesModal={() => openSuccesModal()}
      />
      <PatientSuccess
        show={successModal}
        okayClickHandler={() => setsuccessModal(false)}
      />
      <PatientSuccess
        show={successModal}
        okayClickHandler={() => setsuccessModal(false)}
      />
      {showAuthPopup && (
        <Modal show={showAuthPopup} onHide={handleCloseOtpModal} centered>
          <Modal.Body>
            <div className="modal-width-container">
              <button
                type="button"
                className="video-close"
                data-dismiss="modal"
                onClick={handleCloseOtpModal}
                style={{
                  float: "right",
                  position: "absolute",
                  top: "15px",
                  right: "20px",
                }}
              >
                <img className="" src={CloseIcon} />
              </button>
              <div className="d-flex flex-column align-items-center justify-content-center w-100 mt-5 py-3 px-5">
                <div className="auth-modal-title">Enter OTP</div>
                <div className="auth-modal-text">
                  Please enter the OTP received on your registered mobile number
                </div>
                <AuthPopup
                  success={handleOTPSuccess}
                  close={handleCloseOtpModal}
                />
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}
      <div className="no_web">
        {props.showFilterDoctorMyPatientComponent && (
          <FilterDoctorMyPatientsModal
            doctorFilterList={props.doctorFilterList}
            // doctorNameList={props.selectedDoctorFilter}
            doctorNameList={props.selectedDoctorFilterDrop}
            onFilterSuccess={props.onFilterSuccess}
            onResetFilter={props.onResetFilter}
            doctor_selected={props.doctor_selected}
            temp_doctor_selected={props.temp_doctor_selected}
            // onHandleMethodCall={onHandleMethodCall}
            show={props.showFilterDoctorMyPatientComponent}
            handleClose={() => props.handleShowFilterDoctorMyPatientComponent()}
            selectedFilterStatus={props.selectedFilterStatus}
            setSelectedFilterStatus={props.setSelectedFilterStatus}
            resetFilterData={props.resetFilterData}
            setResetFilterData={props.setResetFilterData}
          />
        )}
      </div>
      <div>
        <DownloadReport
          ref={downloadRef}
          handlePatientDisableDownload={handleDisableDownload}
          downloadReport={downloadReport}
        />
      </div>
    </>
  );
};

export default DoctorMyPatientLayout;
